<template>
  <div id="detalleGastosViaje">
      <v-toolbar>
        <img src="@/assets/logo_javer.png" height="60" width="auto">
        <v-spacer></v-spacer>
        <v-toolbar-title>Detalle de autorización y anticipo de viaje</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6>
              <v-container>
                <h3 class="grey--text">DATOS DEL SOLICITANTE</h3><br/>
                <v-text-field v-model="detalle.beneficiario" label="Beneficiario"></v-text-field>
                <v-text-field v-model="detalle.puesto" label="Puesto"></v-text-field>
                <v-text-field v-model="detalle.empresa" label="Empresa"></v-text-field>
                <v-text-field v-model="detalle.plaza" label="UEN / Plaza"></v-text-field>
                <v-text-field v-model="detalle.departamento" label="Departamento"></v-text-field>
                <v-text-field v-model="detalle.centro" label="Centro de costos"></v-text-field>
                <br/>
                <h3 class="grey--text">DATOS GENERALES DEL ANTICIPO</h3><br/>
                <v-radio-group v-model="detalle.tipo_solicitud" :mandatory="false">
                  <div slot="label"><strong>Tipo de solicitud</strong></div>
                  <v-radio label="Cheque" color="primary" value="cheque"></v-radio>
                  <v-radio label="Transferencia" color="primary" value="transferencia"></v-radio>
                </v-radio-group>
                <template v-if="detalle.tipo_solicitud === 'transferencia'">
                  <v-text-field v-model="detalle.banco" label="Banco"></v-text-field>
                  <v-text-field v-model="detalle.cuenta" label="No. Cuenta"></v-text-field>
                  <v-text-field v-model="detalle.tarjeta" label="No. Tarjeta"></v-text-field>
                  <v-text-field v-model="detalle.clabe" label="Referencia interbancaria"></v-text-field><br/>
                </template>
              </v-container>
            </v-flex>
            <v-flex xs6>
              <v-container>
                <h3 class="grey--text">DATOS DEL VIAJE</h3><br/>
                <v-text-field v-model="detalle.destino" label="Destino"></v-text-field>
                <v-text-field v-model="detalle.motivo_viaje" label="Motivo de viaje"></v-text-field>
                <v-text-field v-model="detalle.fecha_salida" label="Fecha de salida"></v-text-field>
                <v-text-field v-model="detalle.fecha_regreso" label="Fecha de regreso"></v-text-field>
                <v-text-field v-model="detalle.dias_viaje" label="Días de viaje"></v-text-field>
                <br/>
                <v-text-field v-model="detalle.importe_total" label="Importe total" prefix="$" suffix="MXN"></v-text-field>
                <br/>
                <h3 class="grey--text">COMPROBANTES DE VIAJE</h3><br/>
                <v-layout wrap>
                  <v-flex xs6>
                    <v-text-field v-model="detalle.resumen.no_comprobantes" label="No. Comprobantes" readonly></v-text-field>
                    <v-text-field v-model="detalle.resumen.iva" label="IVA" prefix="$" suffix="MXN" readonly></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field v-model="detalle.resumen.subtotal" label="Subtotal" prefix="$" suffix="MXN" readonly></v-text-field>
                    <v-text-field v-model="detalle.resumen.neto" label="Neto" prefix="$" suffix="MXN" readonly></v-text-field>
                  </v-flex>
                </v-layout>
                <br/>
                <h3 class="grey--text">FIRMAS (ANTICIPO)</h3><br/>
                <v-list three-line>
                  <template v-for="(item, i) in detalle.firmas_anticipo">
                    <v-list-tile class="pb-2 pt-2">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                        <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                        <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'" v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-show="(i + 1) < detalle.firmas_anticipo.length"></v-divider>
                  </template>
                </v-list><br/>
                <h3 class="grey--text">FIRMAS (COMPROBACIÓN)</h3><br/>
                <v-list v-if="detalle.firmas_comprobante.length" three-line>
                  <template v-for="(item, i) in detalle.firmas_comprobante">
                    <v-list-tile class="pb-2 pt-2">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                        <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                        <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'" v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-show="(i + 1) < detalle.firmas_comprobante.length"></v-divider>
                  </template>
                </v-list>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import services from '@/config/services'

export default {
  name: 'detalleGastosViaje',
  data: () => ({
    loading: false,
    detalle: {
      id: '',
      beneficiario: '',
      puesto: '',
      empresa: '',
      plaza: '',
      departamento: '',
      centro: '',
      destino: '',
      importe_total: '',
      motivo_viaje: '',
      fecha_salida: '',
      fecha_regreso: '',
      dias_viaje: '',
      ruta_traslado: [],
      tipo_solicitud: null,
      banco: '',
      cuenta: '',
      tarjeta: '',
      clabe: '',
      aerolinea: '',
      hotel: '',
      costo_boleto: '',
      no_noches: '',
      tarifa: '',
      conceptos: [],
      conceptos_sat: [],
      importe_total: '',
      comprobantes: [],
      resumen: {
        no_comprobantes: 0,
        subtotal: 0,
        iva: 0,
        neto: 0
      },
      nuevo_comprobante: {
        tipo_gasto: 'deducible',
        concepto: '',
        pdf: { nombre: '', data: null },
        xml: { nombre: '', data: null },
        foto: { nombre: '', data: null },
        rfc: '',
        beneficiario: '',
        folio: '',
        uuid: '',
        subtotal: '',
        iva: '',
        total: ''
      },
      detalle_comprobante: {
        index: '',
        tipo_gasto: '',
        concepto: '',
        pdf: { nombre: '', data: null },
        xml: { nombre: '', data: null },
        foto: { nombre: '', data: null },
        rfc: '',
        beneficiario: '',
        folio: '',
        uuid: '',
        subtotal: '',
        iva: '',
        total: ''
      },
      firmas_anticipo: [],
      firmas_comprobante: []
    }
  }),
  mounted() {
    var token = this.getQueryVariable('token')
    var id = this.getQueryVariable('id')
    this.$session.start()
    this.$session.set('jwt', token)
    this.showDetailAnt(id)
  },
  methods: {
    ws(method, name, data) {
      if (method === 'get') {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          let params = ''
          for (let k in data) {
            params += k + '=' + data[k] + '&'
          }
          params = (params !== '') ? '?' + params : ''
          return axios.get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
      else {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          return axios.post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
    },
    getQueryVariable(variable) {
       var query = window.location.search.substring(1)
       var vars = query.split("&")
       for (var i = 0; i < vars.length; i++) {
         var pair = vars[i].split("=")
         if (pair[0] == variable){
           return pair[1]
         }
       }
       return(false);
    },
    prepareDetailAnt(id, data) {
      this.detalle.id = id
      this.detalle.beneficiario = data.detalle_usuario.beneficiario
      this.detalle.puesto = data.detalle_usuario.puesto
      this.detalle.empresa = data.detalle_usuario.empresa
      this.detalle.plaza = data.detalle_usuario.plaza
      this.detalle.departamento = data.detalle_usuario.departamento
      this.detalle.estado = data.solicitud.estado
      this.detalle.centro = data.solicitud.centro
      this.detalle.destino = data.solicitud.destino
      this.detalle.motivo_viaje = data.solicitud.motivo_viaje
      this.detalle.fecha_salida = data.solicitud.fecha_salida
      this.detalle.fecha_regreso = data.solicitud.fecha_regreso
      let fecha_salida = moment(this.detalle.fecha_salida, 'YYYY-MM-DD')
      let fecha_regreso = moment(this.detalle.fecha_regreso, 'YYYY-MM-DD')
      this.detalle.dias_viaje = parseInt(fecha_regreso.diff(fecha_salida, 'days')) + 1
      this.detalle.importe_total = data.solicitud.importe_total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.tipo_solicitud = data.solicitud.tipo_solicitud
      this.detalle.banco = data.detalle_usuario.banco
      this.detalle.cuenta = data.detalle_usuario.cuenta
      this.detalle.tarjeta = data.detalle_usuario.tarjeta
      this.detalle.clabe = data.detalle_usuario.clabe
      this.detalle.conceptos = data.conceptos
      this.detalle.conceptos_sat = data.conceptos_sat
      this.detalle.comprobantes = data.comprobantes
      let subtotal = 0
      let iva = 0
      let total = 0
      for (let i = 0; i < this.detalle.comprobantes.length; i++) {
        subtotal += parseFloat(this.detalle.comprobantes[i].subtotal.toFixed(2))
        iva += parseFloat(this.detalle.comprobantes[i].iva.toFixed(2))
        total += parseFloat(this.detalle.comprobantes[i].total.toFixed(2))
      }
      this.detalle.resumen.no_comprobantes = this.detalle.comprobantes.length
      this.detalle.resumen.subtotal = subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.resumen.iva = iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.resumen.neto = total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.firmas_anticipo = data.firmas_anticipo
      this.detalle.firmas_comprobante = data.firmas_comprobante
      this.dialogDetReq = true
    },
    showDetailAnt(id) {
      this.loading = true
      this.ws('get', 'detalleSolicitudAnticipoViaje', { id })
        .then(res => {
          if (res.ok) {
            this.prepareDetailAnt(id, res.data)
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
